<template>
    <div  @keyup.enter="submitForm" v-if="fetched">
        <d-list-group flush>
            <d-list-group-item class="p-3">
                <d-form-row>
                    <d-col md="12" class="form-group">
                        <d-checkbox
                            :value="'1'"
                            :unchecked-value="'0'"
                            toggle
                            v-model="client.client_internal">
                            Klient dla umów wewnętrznych
                        </d-checkbox>
                    </d-col>
                </d-form-row>

                <d-form-row>
                    <d-col md="6" class="form-group">
                        <label>Rodzaj klienta</label>
                        <d-select type="text"
                                  name="type"
                                  v-model="client.type"
                                  @input="lar_errors.clear('type')"
                                  :class="{'is-invalid' : lar_errors.has('type')}"
                                  placeholder="">
                            <option :value="null">--Wybierz rodzaj</option>
                            <option :value="type.value" v-for="type in clientUtils._types" :key="type.id">
                                {{ type.name }}
                            </option>
                        </d-select>
                        <div class="invalid-feedback" v-text="lar_errors.get('type')"></div>
                    </d-col>
                    <d-col md="6" class="form-group">
                        <label>Status</label>
                        <ss-input :disabled="true" class="disabled" :value="'Klient z umową'" v-if="client.status === 'with_contract'"></ss-input>
                        <d-select type="text"
                                  v-else
                                  name="status"
                                  v-model="client.status"
                                  @input="lar_errors.clear('status')"
                                  :class="{'is-invalid' : lar_errors.has('status')}"
                                  placeholder="">
                            <option :value="null">--Wybierz status</option>
                            <option v-if="status.value !== 'with_contract'" :value="status.value" v-for="status in clientUtils._statuses" :key="status.id">
                                {{ status.name }}
                            </option>
                        </d-select>
                        <div class="invalid-feedback" v-text="lar_errors.get('status')"></div>
                    </d-col>
                </d-form-row>

                <d-form-row v-if="client.type !== '' && client.type !== null">
                    <d-col md="6" class="form-group">
                        <ss-input v-if="client.type === 'buisness_activity'" v-model="client.invoice_name" name="invoice_name" label="Nazwa firmy" placeholder="Nazwa firmy"></ss-input>
                        <ss-input v-if="client.type === 'corporation'" v-model="client.invoice_name" name="invoice_name" label="Nazwa spółki" placeholder="Nazwa spółki"></ss-input>
                    </d-col>
                    <d-col md="3" class="form-group">
                        <label for="invoice_tax_number">NIP</label>
                        <d-input id="invoice_tax_number"
                                 type="text"
                                 name="invoice_tax_number"
                                 v-mask="'##########'"
                                 @input="lar_errors.clear('invoice_tax_number')"
                                 :class="{'is-invalid' : lar_errors.has('invoice_tax_number')}"
                                 v-model="client.invoice_tax_number"
                                 placeholder="Nr NIP" />
                        <div class="invalid-feedback" v-text="lar_errors.get('invoice_tax_number')"></div>
                    </d-col>
                    <d-col md="3" class="form-group">
                        <label for="invoice_tax_number">Dane do faktury</label><br />
                        <d-button @click.prevent="downloadNipData" :class="{ isLoading: nip_loading }">Pobierz dane z NIP24</d-button><br />
                        <small>Pobierając dane, nadpiszesz obecne z&nbsp;zakładki "Dane&nbsp;korespondencyjne"</small>
                    </d-col>
                </d-form-row>
                <d-form-row v-if="client.type !== 'corporation'">
                    <d-col md="6" class="form-group">
                        <ss-input v-model="client.name" name="name" label="Imię" placeholder="Imię"></ss-input>
                    </d-col>
                    <d-col md="6" class="form-group">
                        <ss-input v-model="client.surname" name="surname" label="Nazwisko" placeholder="Nazwisko"></ss-input>
                    </d-col>
                </d-form-row>

                <d-form-row v-if="client.type !== 'corporation'">
                    <d-col md="6" class="form-group">
                        <ss-input v-model="client.email" name="email" label="Email" placeholder="Email"></ss-input>
                    </d-col>
                    <d-col md="6" class="form-group">
                        <label for="phone">Telefon</label>
                        <d-input id="phone"
                                 type="text"
                                 name="phone"
                                 @input="lar_errors.clear('phone')"
                                 :class="{'is-invalid' : lar_errors.has('phone')}"
                                 v-model="client.phone"
                                 placeholder="Nr telefonu" />
                        <div class="invalid-feedback" v-text="lar_errors.get('phone')"></div>
                    </d-col>
                </d-form-row>
                <d-form-row>
                </d-form-row>
                <d-form-row v-if="client.type !== 'corporation'">
                    <d-col md="6">
                        <div class="mb-4">
                            <label>Typ dokumentu tożsamości</label>
                            <div v-for="idDocType in idDocumentsTypes">
                                <d-form-radio
                                    name="id_card_type"
                                    v-model="client.id_card_type"
                                    :value="idDocType.value"
                                    default>
                                    {{ idDocType.label }}
                                </d-form-radio>
                            </div>
                        </div>
                    </d-col>
                    <d-col md="6">
                        <label for="id_card">Nr dokumentu tożsamości</label>
                        <d-input
                            id="id_card"
                            name="id_card"
                            v-model="client.id_card"
                            v-mask="getSelectedDocTypeMask(client.id_card_type)"
                            placeholder="Nr dokumentu tożsamości"
                            @input="lar_errors.clear('id_card')"
                            :class="{'is-invalid' : lar_errors.has('id_card')}" />
                    </d-col>
                    <d-col md="6" class="form-group">
                        <label for="pesel">Pesel</label>
                        <d-input id="pesel"
                                 type="text"
                                 name="pesel"
                                 v-mask="'###########'"
                                 @input="lar_errors.clear('pesel')"
                                 :class="{'is-invalid' : lar_errors.has('pesel')}"
                                 v-model="client.pesel"
                                 placeholder="Nr pesel" />
                        <div class="invalid-feedback" v-text="lar_errors.get('pesel')"></div>
                    </d-col>
                </d-form-row>
                <d-form-row v-if="client.type === 'corporation'">
                    <d-col md="6" class="form-group">
                        <label for="regon">Regon</label>
                        <d-input
                                id="regon"
                                name="regon"
                                v-model="client.regon"
                                v-mask="'#########'"
                                @input="lar_errors.clear('regon')"
                                :class="{'is-invalid' : lar_errors.has('regon')}"
                        />
                    </d-col>
                    <d-col md="6" class="form-group">
                        <label for="krs">KRS</label>
                        <d-input
                                id="krs"
                                name="krs"
                                v-model="client.krs"
                                placeholder="KRS"
                                @input="lar_errors.clear('krs')"
                                :class="{'is-invalid' : lar_errors.has('krs')}"
                        />
                    </d-col>
                </d-form-row>
                <d-form-row v-if="client.type === 'buisness_activity'">
                    <d-col md="6" class="form-group">
                        <label>Stan cywilny</label>
                        <d-select
                            type="text"
                            name="marital_status"
                            v-model="client.marital_status"
                            @input="lar_errors.clear('marital_status')"
                            :class="{'is-invalid' : lar_errors.has('marital_status')}"
                            placeholder="">
                            <option :value="null">--Wybierz stan cywilny</option>
                            <option
                                v-for="status in clientUtils._marital_statuses"
                                :key="status.id"
                                :value="status.value">
                                {{ status.name }}
                            </option>
                        </d-select>
                        <div class="invalid-feedback" v-text="lar_errors.get('marital_status')"></div>
                    </d-col>
                    <d-col
                        v-if="client.marital_status === 1"
                        md="6" class="form-group">
                        <label>Rozdzielność majątkowa</label>
                        <d-select
                            type="text"
                            name="property_separation"
                            v-model="client.property_separation"
                            @input="lar_errors.clear('property_separation')"
                            :class="{'is-invalid' : lar_errors.has('property_separation')}"
                            placeholder="">
                            <option :value="null">--Wybierz opcję</option>
                            <option
                                v-for="properties in clientUtils._property_separations"
                                :key="properties.id"
                                :value="properties.value">
                                {{ properties.name }}
                            </option>
                        </d-select>
                        <div class="invalid-feedback" v-text="lar_errors.get('property_separation')"></div>
                    </d-col>
                    <d-col
                        v-else-if="client.marital_status === 2"
                        md="6" class="form-group">
                        <ss-textarea
                            name="marital_status_other"
                            v-model="client.marital_status_other"
                            label="Opis stanu cywilnego"
                            placeholder="Opis..."
                            :rows="2"
                            :class="{'is-invalid' : lar_errors.has('marital_status_other')}">
                        </ss-textarea>
                        <div class="invalid-feedback" v-text="lar_errors.get('marital_status_other')"></div>
                    </d-col>
                </d-form-row>
                <d-checkbox
                    v-if="client.type === 'buisness_activity'"
                    :value="'1'"
                    :unchecked-value="'0'"
                    toggle
                    v-model="client.is_second_person">
                    Pożyczkobiorcą są dwie osoby
                </d-checkbox>
            </d-list-group-item>
        </d-list-group>

        <personal-data-representatives
            v-if="client.type === 'corporation'"
            ref="clientRepresentatives"
            :client-representatives="representatives"
            class="pb-5"/>
        <template v-else-if="client.is_second_person.toString() === '1'">
            <d-card-header class="border-bottom border-top" >
                <h6 class="m-0">Dane drugiej osoby</h6>
            </d-card-header>
            <d-list-group flush>
                <d-list-group-item class="p-3">
                    <d-form>
                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="client.second_name" name="second_name" label="Imię" placeholder="Imię"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="client.second_surname" name="second_surname" label="Nazwisko" placeholder="Nazwisko"></ss-input>
                            </d-col>
                        </d-form-row>

                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="client.second_email" name="second_email" label="Email" placeholder="Email"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <label for="second_phone">Telefon</label>
                                <input id="second_phone"
                                        type="text"
                                        class="form-control"
                                        name="second_phone"
                                        @input="lar_errors.clear('second_phone')"
                                        :class="{'is-invalid' : lar_errors.has('second_phone')}"
                                        v-model="client.second_phone"
                                        placeholder="Nr telefonu" />
                                <div class="invalid-feedback" v-text="lar_errors.get('second_phone')"></div>
                            </d-col>
                        </d-form-row>
                        <d-form-row>
                            <d-col md="6" class="form-group" v-if="client.type !== 'corporation'">
                                <label for="second_pesel">Pesel</label>
                                <d-input id="second_pesel"
                                        type="text"
                                        name="second_pesel"
                                        v-mask="'###########'"
                                        @input="lar_errors.clear('second_pesel')"
                                        :class="{'is-invalid' : lar_errors.has('second_pesel')}"
                                        v-model="client.second_pesel"
                                        placeholder="Nr pesel" />
                                <div class="invalid-feedback" v-text="lar_errors.get('second_pesel')"></div>
                            </d-col>
                        </d-form-row>
                        <d-form-row>
                            <d-col md="6">
                            <div class="mb-4">
                                <label>Typ dokumentu tożsamości</label>
                                <div v-for="idDocType in idDocumentsTypes">
                                    <d-form-radio
                                        name="second_id_card_type"
                                        v-model="client.second_id_card_type"
                                        :value="idDocType.value"
                                        default>
                                        {{ idDocType.label }}
                                    </d-form-radio>
                                </div>
                            </div>
                        </d-col>
                            <d-col md="6" class="form-group">
                                <label for="second_id_card">Nr dokumentu tożsamości</label>
                                <d-input
                                    id="second_id_card"
                                    name="second_id_card"
                                    v-model="client.second_id_card"
                                    v-mask="getSelectedDocTypeMask(client.second_id_card_type)"
                                    placeholder="Nr dokumentu tożsamości"
                                    @input="lar_errors.clear('second_id_card')"
                                    :class="{'is-invalid' : lar_errors.has('second_id_card')}"
                                    />
                            </d-col>
                        </d-form-row>
                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <label>Stan cywilny</label>
                                <d-select
                                    type="text"
                                    name="second_person_marital_status"
                                    v-model="client.second_person_marital_status"
                                    @input="lar_errors.clear('second_person_marital_status')"
                                    :class="{'is-invalid' : lar_errors.has('second_person_marital_status')}"
                                    placeholder="">
                                    <option :value="null">--Wybierz stan cywilny</option>
                                    <option
                                        v-for="status in clientUtils._marital_statuses"
                                        :key="status.id"
                                        :value="status.value">
                                        {{ status.name }}
                                    </option>
                                </d-select>
                                <div class="invalid-feedback" v-text="lar_errors.get('second_person_marital_status')"></div>
                            </d-col>
                            <d-col
                                v-if="client.second_person_marital_status === 1"
                                md="6" class="form-group">
                                <label>Rozdzielność majątkowa</label>
                                <d-select
                                    type="text"
                                    name="second_person_property_separation"
                                    v-model="client.second_person_property_separation"
                                    @input="lar_errors.clear('second_person_property_separation')"
                                    :class="{'is-invalid' : lar_errors.has('second_person_property_separation')}"
                                    placeholder="">
                                    <option :value="null">--Wybierz opcję</option>
                                    <option
                                        v-for="properties in clientUtils._property_separations"
                                        :key="properties.id"
                                        :value="properties.value">
                                        {{ properties.name }}
                                    </option>
                                </d-select>
                                <div class="invalid-feedback" v-text="lar_errors.get('second_person_property_separation')"></div>
                            </d-col>
                            <d-col
                                v-else-if="client.second_person_marital_status === 2"
                                md="6" class="form-group">
                                <ss-textarea
                                    name="second_person_marital_status_other"
                                    v-model="client.second_person_marital_status_other"
                                    label="Opis stanu cywilnego"
                                    placeholder="Opis..."
                                    :rows="2"
                                    :class="{'is-invalid' : lar_errors.has('second_person_marital_status_other')}">
                                </ss-textarea>
                                <div class="invalid-feedback" v-text="lar_errors.get('second_person_marital_status_other')"></div>
                            </d-col>
                        </d-form-row>
                        <d-form-row v-if="client.type !== 'corporation'">
                            <d-col md="6" class="form-group">
                                <label>Rodzaj klienta</label>
                                <d-select type="text"
                                        name="second_type"
                                        v-model="client.second_type"
                                        @input="lar_errors.clear('second_type')"
                                        :class="{'is-invalid' : lar_errors.has('second_type')}"
                                        placeholder="">
                                    <option value="">--Wybierz rodzaj</option>
                                    <option :value="type.value" v-for="type in clientUtils._types" :key="type.id">
                                        {{ type.name }}
                                    </option>
                                </d-select>
                                <div class="invalid-feedback" v-text="lar_errors.get('second_type')"></div>
                            </d-col>
                        </d-form-row>
                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="client.second_residence_street" name="second_residence_street" label="Ulica" placeholder="Ulica"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="client.second_residence_house_number" name="second_residence_house_number" label="Nr budynku" placeholder="Nr budynku"></ss-input>
                            </d-col>
                        </d-form-row>

                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="client.second_residence_flat_number" name="second_residence_flat_number" label="Nr lokalu" placeholder="Nr lokalu"></ss-input>
                            </d-col>
                        </d-form-row>

                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="client.second_residence_postcode" name="second_residence_postcode" label="Kod pocztowy" placeholder="Kod pocztowy"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="client.second_residence_city" name="second_residence_city" label="Miasto" placeholder="Miasto"></ss-input>
                            </d-col>
                        </d-form-row>
                    </d-form>
                </d-list-group-item>
            </d-list-group>
        </template>
    </div>
</template>

<script>
    import LarErrors from '../../helpers/Errors';
    import { mapGetters, mapActions } from 'vuex'
    import clientUtils from '../../utils/client';
    import ssDate from '../../components/common/SsDate';
    import IdDocumentsTypes from '@/data/id-documents-types.js';
    import PersonalDataRepresentatives from '@/components/client/PersonalDataRepresentatives.vue';

    export default {
        name: "PersonalData",
        components: {
            LarErrors,
            clientUtils,
            ssDate,
            PersonalDataRepresentatives
        },
        props: {
            props: {
                default: {},
                type: Object
            },
            representatives: {
                default: () => [],
                type: Array
            }
        },
        data(){
            return{
                lar_errors: LarErrors,
                fetched:    false,
                clientUtils: clientUtils,
                nip_loading: false,
                client: {
                    name:               '',
                    surname:            '',
                    email:              '',
                    phone:              '',
                    pesel:              '',
                    id_card:            '',
                    id_card_type:       'id',
                    regon:              '',
                    krs:                '',
                    company_id:         null,
                    type:               '',
                    status:             null,
                    marital_status: null,
                    property_separation: null,
                    is_second_person:   '0',
                    second_name:        '',
                    second_surname:     '',
                    second_email:       '',
                    second_phone:       '',
                    second_pesel:       '',
                    second_id_card:     '',
                    second_id_card_type:'id',
                    second_type:        '',
                    second_residence_street:        '',
                    second_residence_house_number:  '',
                    second_residence_flat_number:   '',
                    second_residence_postcode:      '',
                    second_residence_city:          '',
                    second_person_marital_status: null,
                    second_person_property_separation: null,
                    invoice_name:       '',
                    invoice_address:    '',
                    invoice_street:     '',
                    invoice_house_number: '',
                    invoice_flat_number:   '',
                    invoice_city:       '',
                    invoice_postcode:   '',
                    invoice_tax_number: '',
                    client_internal:    '0',
                    representatives: []
                },
            }
        },
        computed:{
            ...mapGetters([
                'allCompanies'
            ]),
            idDocumentsTypes () {
                return IdDocumentsTypes;
            }
        },
        methods: {
            ...mapActions([
                'getAllCompanies'
            ]),
            setClientType(){
                if (this.client.second_type === '0'){
                    this.client.second_type = '';
                }
            },
            getSelectedDocTypeMask (docType) {
                let foundType = this.idDocumentsTypes.find(item => item.value === docType);
                if (foundType) {
                    return foundType.mask;
                }

                return 'AAA######';
            },
            downloadNipData(){
                this.nip_loading = true;
                if (!this.client.invoice_tax_number) {
                    this.nipErrorMessage()
                } else {
                    axios.post('api/clients/get-data-by-nip', {
                        nip: this.client.invoice_tax_number
                    }).then(response => {
                        const data = response.data;
                        if (!data.name) {
                            this.nipErrorMessage()
                        } else {
                            this.client.invoice_name = data.name;
                            this.client.invoice_postcode = data.post_code;
                            this.client.invoice_city = data.post_city;
                            this.client.invoice_street = data.street;
                            this.client.invoice_house_number = data.street_number;
                            this.client.invoice_flat_number = data.house_number;

                            this.client.business_postcode = data.post_code;
                            this.client.business_city = data.post_city;
                            this.client.business_street = data.street;
                            this.client.business_house_number = data.street_number;
                            this.client.business_flat_number = data.house_number;
                            if(this.client.type === 'buisness_activity'){
                                this.client.name = data.firstname;
                                this.client.surname = data.lastname;
                            }
                        }
                        this.nip_loading = false;
                        Vue.swal({
                            title: 'Dane zostały zaktualizowane',
                            text: 'Pomyślnie pobraliśmy dane do faktury. Twoje dane zostały zaktualizowane także w zakładce "Dane korespondencyjne". Pamiętaj aby zapisać klienta, jeśli chcesz aby zmiany zostały zachowane.',
                            type: 'success',
                        });
                    }).catch((error) =>{
                        this.nipErrorMessage();
                        LarErrors.record(error.response.data.errors)
                    })
                }
            },
            nipErrorMessage() {
                Vue.swal({
                    title: 'Nie udało się pobrać danych',
                    text: 'Wystąpił błąd podczas pobierania. Sprawdź poprawność danych lub spróbuj ponownie za jakiś czas.',
                    type: 'error',
                });
                this.nip_loading = false;
            },
            getRepresentatives () {
                if (this.client.type === 'buisness_activity') {
                    return [];
                }

                return this.$refs.clientRepresentatives.getRepresentatives();
            }
        },
        mounted(){
            this.getAllCompanies();

            if (this.props) {
                this.client = this.props;
            }

            this.fetched = true;
        },
        watch: {
            props: {
                handler: function(to) {
                    this.client = to;
                    this.setClientType();
                },
                deep: true
            }
        }
    }
</script>
